
import http from "./Endpoint";

class ProductService {

  projection = {
    "order_by": {
      "name": "ASC"
    },
    "limit": 100,
    "offset": 0
  }

  /**
   * Get product categories for a customer
   * @param [] data - array of category Ids
   * @returns 
   */
  categories(customerId) {
    let article = {
      "filter": {
        customer_id: customerId,
        exclude_no_product: 1
      }
    };
    return http().post("/product/categories", article);
  }

  /**
   * Get product information
   * @param {*} productId - Product Id
   * @returns 
   */
  query(productId) {
    let article = {
      "filter": { "id": productId },
      "return": [
        "id",
        "customer_id",
        "name",
        "quickbooks_type_id",
        "customer_sku",
        "min_quantity",
        "max_quantity",
        "additional_info",
        "package_quantity",
        "is_customizable",
        "is_mailable",
        "no_upload",
        "show_inventory",
        "use_quantities_dropdown",
        "is_in_inventory",
        "no_order_below_zero_inventory",
        "pick_fees",
        "quantity_list",
        "modifier",
        "category",
        "actual_inventory",
        "estimate_delivery_date",
      ]
    }
    return http().post("/product/query", article);
  }

  /**
   * List products for a category or customer
   * @param {*} data 
   * @returns 
   */
  list(filter) {
    let article = {
      "filter": filter,
      projection: this.projection,
      "return": [
        "id",
        "name",
        "product_category_id",
        "min_quantity",
        "max_quantity",
        "additional_info",
        "package_quantity",
        "is_customizable",
        "is_mailable",
        "no_upload",
        "show_inventory",
        "use_quantities_dropdown",
        "quickbooks_type_id",
        "customer_sku",
        "is_in_inventory",
        "no_order_below_zero_inventory"
      ]
    }
    return http().post("/product/list", article);
  }

  add(data) {

  }

  enum(data) {

  }

  clone(data) {

  }


}

export default new ProductService();